import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { Router, NavigationEnd } from "@angular/router";

@Component({
  selector: 'calsoft-date-format-issue',
  templateUrl: './date-format-issue.component.html',
  styleUrls: ['./date-format-issue.component.scss']
})
export class DateFormatIssueComponent implements OnInit {

  url = '';
  sanitizedUrl = '';

  @Input() date :any;

  currentDate:any;

  constructor(private datePipe: DatePipe, private router: Router){
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
    
  }
 
  ngOnInit(): void {
  
    this.currentDate = this.datePipe.transform(this.date, 'yyyy-MM-dd HH:mm:ss', 'IST');

    

  }

    protected _onDestroy = new Subject<void>();

    sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
